import { render, staticRenderFns } from "./PrintableSearchResults.vue?vue&type=template&id=64ea8bae&scoped=true&"
import script from "./PrintableSearchResults.vue?vue&type=script&lang=ts&"
export * from "./PrintableSearchResults.vue?vue&type=script&lang=ts&"
import style0 from "./PrintableSearchResults.vue?vue&type=style&index=0&id=64ea8bae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ea8bae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
